import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { LotRecommendationType } from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';
import { trackLotRecommendationSeenAnalytics } from '@/utils/amplitude/analytics/item/trackLotRecommendationSeen.analytics';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import useVisibilitySensor from '@rooks/use-visibility-sensor';

type Props = {
    children: React.ReactNode;
    recommendationIds: number[];
    recommendationType: LotRecommendationType;
};

const INTERVAL_CHECK_MS = 750;

export const RecommendationVisibilityWrapper = ({ children, recommendationIds, recommendationType }: Props) => {
    const moduleRef = useRef(null);
    const [hasVisibilityBeenTracked, setHasVisibilityBeenTracked] = useState(false);
    const location = useLocation();

    const { isVisible } = useVisibilitySensor(moduleRef, {
        intervalCheck: INTERVAL_CHECK_MS,
        minTopValue: 0,
        partialVisibility: true,
        resizeCheck: true,
        scrollCheck: true,
    });

    useEffect(() => {
        if (isVisible && !hasVisibilityBeenTracked) {
            trackLotRecommendationSeenAnalytics({
                pageName: getAmplitudePageNameFromPath(location.pathname),
                recommendationIds,
                recommendationName: recommendationType,
                url: window.location.href,
            });
            setHasVisibilityBeenTracked(true);
        }
    }, [isVisible, hasVisibilityBeenTracked, recommendationType, recommendationIds, location.pathname]);

    return <div ref={moduleRef}>{children}</div>;
};
